module.exports = __webpack_public_path__ + "static/media/13_l_colona_0_4.91.2236d5db.png";